var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form-filtered-select',{attrs:{"selected-key":_vm.selectedCurrency ? _vm.selectedCurrency.value : null,"options":_vm.currencyOptions,"invalid":_vm.invalid,"placeholder":"Currency"},on:{"updateDropdownValue":_vm.onUpdateValue,"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }